<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">签到管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div>
            <el-switch
            v-model="signsettingForm.is_open"
            active-color="#13ce66"
            inactive-color="#ff4949">
            </el-switch>
            签到活动已开启
        </div>
        <div class="signContent">
            <div class="signContent_li" v-for="item of list" :key="item.id">
                <div>签到第{{ item.days}}天</div>
                <el-input placeholder="请输入" style="width:400px;margin-left:20px" v-model="item.rewards">
                    <template slot="append">约豆</template>
                    <template slot="prepend">当日签到送</template>
                </el-input>
            </div>
            <div class="signContent_li" >
                <div>连续签到7天额外送</div>
                <el-input placeholder="请输入" style="width:400px;margin-left:20px" v-model="signsettingForm.maxsign">
                    <template slot="append">约豆</template>
                </el-input>
            </div>
            <div style="text-align:center;margin-top:30px">
                <el-button type="primary" @click="submit()">保存</el-button>
            </div>
        </div>
    </div>
</template>
<script> 
import { signrewardsList , signsettingList , signrewardsUpdate , signsettingUpload } from '../../api/userMG'

export default {
    data(){
        return{
            value:false,
            list:[],
            signsettingForm:{}
        }
    },
    created(){
        this.signrewardsList()
        this.signsettingList()
    },
    methods:{
        submit(){
            signrewardsUpdate(this.list).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    signsettingUpload(this.signsettingForm).then(setRes=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else{
                            this.$message.success('修改成功')
                        }
                    })
                }
            })
        },
        signsettingList(){
            signsettingList().then(res=>{
                this.signsettingForm = res.data
            })
        },  
        signrewardsList(){
            signrewardsList().then(res=>{
                this.list = res.data
            })
        }
    }
}
</script>

<style scoped>

.signContent{
    padding: 30px ;
    background: #f4f4f4;
    margin-top: 30px;
}
.signContent_li{
    display: flex;
    align-items: center;
    margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/ActivityCenter/SignInManagement.vue